import * as React from 'react'
import cn from 'classnames'
import ChevronDownIcon from '../../icons/chevron_down.svg'

interface IProps {
  currentPage: number
  totalItems: number
  pageSize: number
  onPageChange: (page: number) => void
  className?: string
}

const MAX_VISIBLE_PAGES = 5

const Pagination: React.FC<IProps> = ({
  currentPage,
  totalItems,
  pageSize,
  onPageChange,
  className,
}) => {
  const totalPages = Math.ceil(totalItems / pageSize)

  if (totalPages <= 1) return null

  const half = Math.floor(MAX_VISIBLE_PAGES / 2)
  let startPage = Math.max(1, currentPage - half)
  const endPage = Math.min(totalPages, startPage + MAX_VISIBLE_PAGES - 1)
  startPage = Math.max(1, endPage - MAX_VISIBLE_PAGES + 1)

  const pages: number[] = []
  for (let i = startPage; i <= endPage; i++) {
    pages.push(i)
  }

  const from = (currentPage - 1) * pageSize + 1
  const to = Math.min(currentPage * pageSize, totalItems)

  return (
    <div className={cn('pagination', className)}>
      <div className="pagination_pages">
        <button
          type="button"
          className="clear-button pagination_arrow -prev"
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          <ChevronDownIcon />
        </button>
        {pages.map((p) => (
          <button
            key={p}
            type="button"
            className={cn('clear-button', 'pagination_page', {
              '-active': p === currentPage,
            })}
            onClick={() => onPageChange(p)}
          >
            {p}
          </button>
        ))}
        <button
          type="button"
          className="clear-button pagination_arrow"
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          <ChevronDownIcon />
        </button>
      </div>
      <div className="pagination_info">
        {from}-{to} / {totalItems} items
      </div>
    </div>
  )
}

export default Pagination
